$(document).ready(function(){
  // #upsell_slider on theme.js 5874 line and 5826
  $(document).on('click','.mini-cart button.upsell_btn',function(){
    console.log('hh');
    $(this).addClass('loading');
    var id = $(this).data('pro-id');
    console.log(id);
    var arrPdp = [];
    if(id != ''){    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        $('.mini-cart button.upsell_btn').removeClass('loading');
        // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        }));  
        
       } 
      });
    }
  });  
  if($('body').hasClass('template-product')){
     $(document).find('.template-product #upsell_slider').slick({
          infinite: false,
          slidesToShow: 1.4,
          slidesToScroll: 1,
          arrows:false
        });
    
   $(document).on('click','.product__info button.upsell_btn',function(){
    console.log('pro');
     $(this).addClass('loading');
    var id = $(this).data('pro-id');
    console.log(id);
    var arrPdp = [];
    if(id != ''){    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        
        // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        })); 
        var cartDrawerButtonSelector = "a.header__icon-wrapper[aria-controls='mini-cart']";
        var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
        setTimeout(function() {
        cartDrawerButton.click();
        $('.product__info button.upsell_btn').removeClass('loading');
        }, 1000);
       } 
      });
    }
  });
  }


  // $('.shopify-section--product-recommendations .product-list__inner').slick({
  //   infinite: false,
  //   dots: true,
  //   arrows: false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //   {
  //     breakpoint: 1200,
  //     settings: {
  //       slidesToShow: 2.4,
  //       slidesToScroll: 1
  //     }
  //   },
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 1.4,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
  // });
  
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".playbutton").forEach(function(wrapper) {
    const video = wrapper.querySelector("video");
    if (!video) return;

    // Create overlay button
    const overlay = document.createElement("div");
    overlay.className = "custom-play-overlay";
    overlay.innerHTML = "&#9658;"; // play triangle
    wrapper.appendChild(overlay);

    overlay.addEventListener("click", function() {
      video.play();
      overlay.style.display = "none"; // hide after play
    });

    // Optional: hide overlay if user uses native controls
    video.addEventListener("play", function() {
      overlay.style.display = "none";
    });
    video.addEventListener("pause", function() {
      overlay.style.display = "block";
    });
  });
});




// Add "FAQ" tab to BOTH desktop and mobile; scroll to .faq with offset (-200 desktop, -100 mobile)
document.addEventListener("DOMContentLoaded", () => {
  const faqSection = document.querySelector(".faq");
  if (!faqSection) return;

  const OFFSET_DESKTOP = 300;
  const OFFSET_MOBILE = 200;

  const scrollToFaq = () => {
    const rect = faqSection.getBoundingClientRect();
    const top = window.scrollY + rect.top;
    const offset = window.innerWidth > 768 ? OFFSET_DESKTOP : OFFSET_MOBILE;
    window.scrollTo({ top: top - offset, behavior: "smooth" });
  };

  // ---------- DESKTOP TAB ----------
  (function addDesktopTab() {
    const tabsList = document.querySelector(".tabs-nav__item-list");
    if (!tabsList || document.getElementById("faq-desktop-btn")) return;

    const btn = document.createElement("button");
    btn.id = "faq-desktop-btn";
    btn.type = "button";
    btn.className = "tabs-nav__item heading heading--small";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", "gotofaq");
    btn.textContent = "FAQ";

    tabsList.appendChild(btn);

    btn.addEventListener("click", () => {
      // mirror active state like other tabs
      tabsList.querySelectorAll(".tabs-nav__item").forEach(el => el.setAttribute("aria-expanded", "false"));
      btn.setAttribute("aria-expanded", "true");
      scrollToFaq();
      // optional: reset after a moment so tab styles return if needed
      setTimeout(() => btn.setAttribute("aria-expanded", "false"), 400);
    });
  })();

  // ---------- MOBILE TAB ----------
  (function addMobileTab() {
    const mobileTabsContent = document.querySelector(".product-tabs__content");
    if (!mobileTabsContent || document.getElementById("faq-mobile-tab-wrapper")) return;

    const wrapper = document.createElement("div");
    wrapper.id = "faq-mobile-tab-wrapper";
    wrapper.className = "product-tabs__tab-item-wrapper";
    wrapper.hidden = true; // match the hidden wrappers pattern

    const btn = document.createElement("button");
    btn.setAttribute("is", "toggle-button");
    btn.className = "collapsible-toggle heading heading--small hidden-lap-and-up";
    btn.setAttribute("aria-controls", "faq-mobile-content");
    btn.setAttribute("aria-expanded", "false");
    btn.textContent = "FAQ";

    const coll = document.createElement("collapsible-content");
    coll.id = "faq-mobile-content";
    coll.className = "collapsible";
    const inner = document.createElement("div");
    inner.className = "product-tabs__tab-item-content";
    coll.appendChild(inner);

    wrapper.appendChild(btn);
    wrapper.appendChild(coll);
    mobileTabsContent.appendChild(wrapper);

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.setAttribute("aria-expanded", "true");
      scrollToFaq();
      setTimeout(() => btn.setAttribute("aria-expanded", "false"), 400);
    });
  })();
});
